import { Asterisk } from "lucide-react";

const WORDS = ["Branding", "Marketing", "Social", "Web", "Film", "Strategy"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y py-8 md:py-10 bg-dm-cream"
      style={{ borderColor: "rgba(39,90,113,0.15)" }}
    >
      <div className="flex whitespace-nowrap animate-marquee marquee-slow">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className="font-display font-extrabold tracking-tight text-5xl md:text-7xl px-6"
              style={{ color: i % 2 === 0 ? "var(--dm-teal)" : "var(--dm-maroon)" }}
            >
              {w}
            </span>
            <Asterisk className="mx-2" size={34} style={{ color: "var(--dm-maroon)" }} />
          </div>
        ))}
      </div>
    </section>
  );
}
